var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"width":"1200"},model:{value:(_vm.showPolicyPopup),callback:function ($$v) {_vm.showPolicyPopup=$$v},expression:"showPolicyPopup"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('popupPolicyHtml'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }